import {ActionReducerMapBuilder} from '@reduxjs/toolkit';

import {VendorProState} from './slicer';
import {
  confirmVendorPro,
  createVendorProSnapshot,
  deleteVendorPro,
  getVendorProDetail,
  getVendorProList,
  getVendorProPlans,
  markVendorProDone,
  pauseVendorPro
} from './thunk';

export const vendorProBuilder = (builder: ActionReducerMapBuilder<VendorProState>) => {
  builder
    .addCase(getVendorProList.pending, (state: any) => {
      state.loading = true;
    })
    .addCase(getVendorProList.fulfilled, (state: any, action: any) => {
      const payload = action.payload;
      console.log(payload);
      if (state.list && state.list.page !== payload?.page) {
        state.list = {
          ...payload,
          items: [...(state.list.items || []), ...(payload.items || [])]
        };
      } else {
        state.list = payload;
      }
      state.loading = false;
    })
    .addCase(getVendorProList.rejected, (state: any) => {
      state.loading = false;
    })
    .addCase(createVendorProSnapshot.pending, (state: any) => {
      state.create.loading = true;
    })
    .addCase(createVendorProSnapshot.fulfilled, (state: any) => {
      state.create.loading = false;
    })
    .addCase(createVendorProSnapshot.rejected, (state: any) => {
      state.create.loading = false;
    })
    .addCase(getVendorProPlans.pending, (state: any) => {
      state.plansLoading = true;
    })
    .addCase(getVendorProPlans.fulfilled, (state: any, action: any) => {
      state.plans = action.payload.data;
      state.plansLoading = false;
    })
    .addCase(getVendorProPlans.rejected, (state: any) => {
      state.plansLoading = false;
    })
    .addCase(confirmVendorPro.pending, (state: any) => {
      state.confirm.loading = true;
    })
    .addCase(confirmVendorPro.fulfilled, (state: any, action: any) => {
      state.confirm.loading = false;
      state.confirm.result = action.payload;
    })
    .addCase(confirmVendorPro.rejected, (state: any) => {
      state.confirm.loading = false;
    })
    .addCase(getVendorProDetail.pending, (state: any) => {
      state.detailLoading = true;
      state.details = null;
    })
    .addCase(getVendorProDetail.fulfilled, (state: any, action: any) => {
      state.details = action.payload.data;
      state.detailLoading = false;
    })
    .addCase(getVendorProDetail.rejected, (state: any) => {
      state.detailLoading = false;
      state.details = null;
    })
    .addCase(deleteVendorPro.pending, (state: any) => {
      state.remove.loading = true;
    })
    .addCase(deleteVendorPro.fulfilled, (state: any) => {
      state.remove.loading = false;
    })
    .addCase(deleteVendorPro.rejected, (state: any) => {
      state.remove.loading = false;
    })
    .addCase(markVendorProDone.pending, (state: any) => {
      state.done.loading = true;
    })
    .addCase(markVendorProDone.fulfilled, (state: any) => {
      state.done.loading = false;
    })
    .addCase(markVendorProDone.rejected, (state: any) => {
      state.done.loading = false;
    })
    .addCase(pauseVendorPro.pending, (state: any) => {
      state.pause.loading = true;
    })
    .addCase(pauseVendorPro.fulfilled, (state: any) => {
      state.pause.loading = false;
    })
    .addCase(pauseVendorPro.rejected, (state: any) => {
      state.pause.loading = false;
    });
};
